import React, { useCallback, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { SERVICES } from "../data/services";
import ServiceCard, { ServiceCardStyles } from "./ServiceCard";

/**
 * Service carousel — auto-scrolling row of chrome-framed service cards.
 * Card visuals + hover animations live in `ServiceCard`; this component only
 * handles the Embla loop + autoplay.
 */
export default function ServiceCarousel() {
  const autoplay = Autoplay({ delay: 1600, stopOnInteraction: false, stopOnMouseEnter: true });
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, dragFree: false, align: "start", containScroll: "trimSnaps" },
    [autoplay]
  );

  const onSelect = useCallback(() => {
    const ap = emblaApi?.plugins()?.autoplay;
    if (ap && !ap.isPlaying()) ap.play();
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("pointerUp", onSelect);
    return () => { emblaApi.off("pointerUp", onSelect); };
  }, [emblaApi, onSelect]);

  return (
    <section className="relative pt-0 sm:pt-2 md:pt-4 pb-6 sm:pb-8 md:pb-10 -mt-16 sm:-mt-20 md:-mt-24 overflow-hidden" data-testid="service-carousel">
      <ServiceCardStyles />
      <div className="relative overflow-hidden" ref={emblaRef}>
        <div className="flex gap-4 sm:gap-5 md:gap-6 px-5 sm:px-6 md:px-10">
          {SERVICES.map((s, i) => (
            <div
              key={s.slug}
              className="shrink-0 basis-[58%] sm:basis-[34%] md:basis-[24%] lg:basis-[18%]"
            >
              <ServiceCard service={s} index={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
